import propActive from '@/assets/images/prop-active.svg';
import propAlert from '@/assets/images/prop-alert.svg';
import propAttention from '@/assets/images/prop-attention.svg';
import propCancellation from '@/assets/images/prop-cancellation.svg';
import propInactive from '@/assets/images/prop-inactive.svg';
import propMatchup from '@/assets/images/prop-matchup.svg';
import propQueue from '@/assets/images/prop-queue.svg';
import { SUB_STATUS_ID } from './constants';

/**
 * How a sub-status is drawn: the row icon and the left-border strip colour.
 *
 * Both maps are keyed by scheduler_sub_status.id, not by the display label — see SUB_STATUS_ID.
 * They live here rather than in each page so that adding a sub-status means one entry in each
 * map below plus a `.status-strips-*` rule in Phoenix.scss, instead of an edit to the icon
 * ternary in SubStatus.jsx, ScenarioBuilder and the strip ternary in both dashlets and the leg
 * list. Callers pass the highest-priority sub-status for the row (filterDataByHighestPriority).
 */
const SUB_STATUS_ICONS = {
  [SUB_STATUS_ID.ACTIVE]: propActive,
  [SUB_STATUS_ID.INACTIVE]: propInactive,
  [SUB_STATUS_ID.CX]: propCancellation,
  [SUB_STATUS_ID.MATCHUP]: propMatchup,
  [SUB_STATUS_ID.MX]: propAlert,
  [SUB_STATUS_ID.QUEUE]: propQueue,
  [SUB_STATUS_ID.ATTENTION_NEEDED]: propAttention,
  // New (7) is system-assigned and deliberately has no icon — callers render nothing for it.
};

const SUB_STATUS_STRIP_CLASSES = {
  [SUB_STATUS_ID.MX]: 'status-strips-yellow',
  [SUB_STATUS_ID.ATTENTION_NEEDED]: 'status-strips-attention',
  [SUB_STATUS_ID.CX]: 'status-strips-red',
  [SUB_STATUS_ID.MATCHUP]: 'status-strips-green',
};

const DEFAULT_STRIP_CLASS = 'status-strips-gray';

/**
 * @param {number} [id] scheduler_sub_status id
 * @returns {string|undefined} icon source, or undefined when the status has no icon
 */
export const getSubStatusIcon = (id) => SUB_STATUS_ICONS[id];

/**
 * @param {number} [id] scheduler_sub_status id
 * @returns {string} strip class for the row, falling back to the neutral grey strip
 */
export const getSubStatusStripClass = (id) => SUB_STATUS_STRIP_CLASSES[id] || DEFAULT_STRIP_CLASS;
